import { Text as Text$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Text = createRemoteReactComponent(Text$1);

export { Text };
